import React from 'react';
import {
    Container,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import CodLimitTable from './CodLimitTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function CodLimitView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.cod_limits')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.cod_limits')}
                </Typography>
                <CodLimitTable />
            </Container>
        </Page>
    );
}